<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Editar Coacreedor {{ beneficiary.id }}
        </div>
      </div>
      <div class="card-body pb-5">
        <hr class="mt-4"/>
        <!--begin: Beneficiary Update -->
          <sys-form :inputs="beneficiary_details"/>
        <!--end: Beneficiary Update -->
        <hr class="mt-4"/>
        <!--begin: Fiscal Info -->
          <div class="row mt-4">
              <div class="col-sm col-md col-lg">
                  <h4 class="m--font-info">Datos bancarios</h4>
              </div>
          </div>
          <sys-form :inputs="beneficiary_bank_account"/>
        <!--end: Fiscal Info -->
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.go(-1)">
          <fai icon="reply"/> Cancelar
        </button>
       <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import banksService from '@/services/banks'
import contractsService from '@/services/contracts'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  name: 'BeneficiaryUpdate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      loaded: false,
      beneficiary: {},
      beneficiary_details: {
        name: {
          name: 'Nombre',
          hint: 'Nombre',
          value: '',
          type: 'text',
          size: 4,
          validate: 'required'
        },
        lastname_father: {
          name: 'Apellido paterno',
          hint: 'Apellido paterno',
          value: '',
          type: 'text',
          size: 4,
          validate: 'required'
        },
        lastname_mother: {
          name: 'Apellido materno',
          hint: 'Apellido materno',
          value: '',
          type: 'text',
          size: 4,
          validate: 'required'
        },
        telephone: {
          name: 'Teléfono',
          hint: 'Teléfono',
          value: '',
          type: 'text',
          size: 4
        },
        email: {
          name: 'Correo eléctronico',
          hint: 'Correo eléctronico',
          value: '',
          type: 'email',
          size: 4
        },
        dob: {
          name: 'Fecha de nacimiento',
          hint: 'Fecha de nacimiento',
          value: '',
          type: 'date',
          size: 4
        },
        percentage: {
          name: 'Porcentaje',
          hint: 'Porcentaje',
          value: '',
          type: 'number',
          size: 4,
          validate: 'required'
        },
        rfc: {
          name: 'RFC',
          hint: 'RFC',
          value: '',
          type: 'text'
        },
        clave_id: {
          name: 'Clave Dispersión',
          hint: 'Id para Pagos',
          value: '',
          type: 'text'
        },
        zip: {
          name: 'Código Postal',
          hint: 'C.P.',
          value: '',
          type: 'number'
        },
        street: {
          name: 'Calle',
          hint: 'Calle',
          value: '',
          type: 'text'
        },
        number: {
          name: 'Número ext./int.',
          hint: 'Número ext./int.',
          value: '',
          type: 'number',
          min: 0,
          max: 9999
        },
        neighborhood: {
          name: 'Colonia',
          hint: 'Colonia',
          value: '',
          type: 'text'
        },
        city: {
          name: 'Municipio',
          hint: 'Municipio',
          value: '',
          type: 'text'
        },
        state: {
          name: 'Estado',
          hint: 'Estado',
          value: '',
          type: 'text'
        }
      },
      beneficiary_bank_account: {
        holder: {
          name: 'Cuenta Habiente',
          hint: 'Nombre Apellidos',
          value: '',
          type: 'text',
          size: 6
        },
        bank_id: {
          name: 'Banco',
          hint: 'Seleccione un banco',
          value: null,
          type: 'select',
          size: 6,
          options: []
        },
        account: {
          name: 'Cuenta Bancaria',
          hint: 'Cuenta Bancaria',
          value: '',
          type: 'text',
          size: 6,
          validate: 'isBankAccount'
        },
        clabe: {
          name: 'Clabe',
          hint: 'Clabe',
          value: '',
          type: 'text',
          size: 6,
          validate: 'isClabe'
        }
      }
    }
  },

  created: function () {
    this.loaded = false
    const id = this.$route.params.id
    contractsService.getBeneficiary(id).then(res => {
      this.beneficiary = res.data
      Object.keys(this.beneficiary_details).forEach(key => {
        this.beneficiary_details[key].value = this.beneficiary[key]
      })
      this.beneficiary_bank_account.account.value = this.beneficiary['account']
      banksService.list().then(res => {
        this.beneficiary_bank_account.bank_id.options = res.map(bank => {
          if (this.beneficiary['bank_id'] == bank.id) {
            this.beneficiary_bank_account.bank_id.value = { value: bank.id, text: bank.name }
          }
          return { value: bank.id, text: bank.name }
        })
      })
      this.beneficiary_bank_account.holder.value = this.beneficiary['holder']
      this.beneficiary_bank_account.clabe.value = this.beneficiary['clabe']
    })
    this.loaded = true
  },

  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let body = this.processForm(this.beneficiary_details)
          let bankAccountData = this.processForm(this.beneficiary_bank_account)
          if (Object.keys(bankAccountData).length) body['bank_account_data'] = bankAccountData
          let contractId = this.$route.params.contract_id
          let id = this.$route.params.id

          contractsService.updateBeneficiary(id, body).then(res => {
            if (res.error) {
              console.log(JSON.stringify(res.error))
              alert(res.error.message)
            } else {
              this.$router.push({ name: 'contract', params: { id: contractId } })
            }
          }).catch(err => {
            if (err) {
              console.log(JSON.stringify(err.statusText))
              alert(err.statusText)
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contracts/beneficiaries/BeneficiaryUpdate.vue